import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AuthHttpInterceptor, ClientDetailsApiInterceptor, TranslationLoaderFactory } from '@monorepo/services';
import { UiModule } from '@monorepo/ui';
import { LoggerModule, NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppShellModule } from './app-shell/app-shell.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { StateModule } from './state/store.module';
import { UICompModule } from './ui-components/ui-components.module';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { Zip } from '@ionic-native/zip/ngx';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [AppComponent],
  imports: [
    IonicStorageModule.forRoot({
      name: '__userDataBase',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    HttpClientModule,
    BrowserModule,
    UiModule,
    IonicModule.forRoot(),
    CoreModule,
    AppRoutingModule,
    AppShellModule,
    StateModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.ERROR,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('oi-app');
        },
        deps: [HttpClient],
      },
    }),
    UICompModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    HttpClient,
    HttpClientModule,
    InAppBrowser,
    FileOpener,
    NGXLogger,
    { provide: 'Zip', useClass: Zip },
    { provide: 'environment', useValue: environment },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ClientDetailsApiInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
